import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import * as React from "react";
import styled, { css } from "styled-components";
import { accordionTransitionTiming } from "@faire/retailer/components/Accordion/Accordion";
import { AnimatedChevronContainer } from "@faire/retailer/components/Accordion/AnimatedChevronContainer";
import { ExpandedContent } from "@faire/retailer/components/Accordion/ExpandedContent";
import { FullControlAccordion } from "@faire/retailer/components/Accordion/FullControlAccordion";
import { Chevron } from "@faire/retailer/icons/Chevron/Chevron";
export var QuestionAccordion = function(param) {
    var information = param.information, openIndex = param.openIndex, toggleAccordionItem = param.onItemClick, onView = param.onView;
    var viewRef = useDoActionWhenVisible(onView);
    return /*#__PURE__*/ _jsx(Column, {
        ref: onView ? viewRef : undefined,
        flex: 1,
        style: {
            width: "100%"
        },
        children: information.map(function(param, index) {
            var question = param.question, answer = param.answer;
            return /*#__PURE__*/ _jsxs(FullControlAccordion, {
                isOpen: openIndex === index,
                onClick: function() {
                    return toggleAccordionItem(index);
                },
                children: [
                    index === 0 ? /*#__PURE__*/ _jsx(Separator, {
                        $first: true
                    }) : null,
                    /*#__PURE__*/ _jsxs(AccordionItem, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        as: "span",
                                        variant: {
                                            mobileAndAbove: "paragraphSansRegular",
                                            tabletAndAbove: "subheadingSansRegular"
                                        },
                                        children: question
                                    }),
                                    /*#__PURE__*/ _jsx(AnimatedChevronContainer, {
                                        children: /*#__PURE__*/ _jsx(Chevron, {
                                            direction: "right",
                                            height: 12,
                                            width: 12
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ExpandedContent, {
                                stopPropagation: true,
                                children: [
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        as: "span",
                                        variant: {
                                            mobileAndAbove: "paragraphSansRegular",
                                            tabletAndAbove: "subheadingSansRegular"
                                        },
                                        children: answer
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Separator, {})
                ]
            }, question);
        })
    });
};
var AccordionItem = styled.div.withConfig({
    componentId: "sc-6b0f8a99-0"
})([
    "padding:",
    ";",
    "{padding:",
    ";}",
    ""
], getSpacing("2x", "4x"), responsiveMediaQueries.mobile, getSpacing("2x", "3x"), accordionTransitionTiming);
var Separator = styled.hr.withConfig({
    componentId: "sc-6b0f8a99-1"
})([
    "display:block;margin:0;padding:0;border:0;",
    "{",
    " height:1px;border-top:1px solid ",
    ";}",
    "{height:1px;",
    "}"
], responsiveMediaQueries.mobile, function(props) {
    return props.$first ? css([
        "display:none;"
    ]) : css([
        ""
    ]);
}, Core.border.muted, responsiveMediaQueries.tabletAndAbove, function(props) {
    return props.$first ? css([
        "border:0.5px solid ",
        ";"
    ], Core.border.subdued) : css([
        "border-top:0.5px solid ",
        ";"
    ], Core.border.subdued);
});
